import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAppStore, useLocalStore } from '~/stores'

export const Route = createFileRoute('/profile/account')({
  beforeLoad: async () => {
    const { activeWorkspace } = useAppStore.getState()
    const { lastActiveWorkspaceId } = useLocalStore.getState()

    const workspaceId = activeWorkspace?.id ?? lastActiveWorkspaceId

    if (!workspaceId) {
      throw redirect({ to: '/workspaces' })
    }

    throw redirect({
      to: '/workspaces/$workspaceId/profile/account',
      params: { workspaceId },
    })
  },
})
